import './MinisterResumeSelectModal.scss';
import type { MyResumeItem } from './useMinisterAccess';

interface MinisterResumeSelectModalProps {
  resumeList: MyResumeItem[];
  onClose: () => void;
  onSelect: (id: string) => void;
}

const formatDate = (value: string) => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('ko-KR');
};

// 사역자정보 '내 정보 보기' — 이력서가 2개 이상일 때 확인할 이력서 선택
export default function MinisterResumeSelectModal({ resumeList, onClose, onSelect }: MinisterResumeSelectModalProps) {
  return (
    <div className="resume-select-modal-overlay" onClick={onClose}>
      <div className="resume-select-modal" onClick={(e) => e.stopPropagation()}>
        <div className="resume-select-modal__header">
          <div className="resume-select-modal__title">확인할 이력서를 선택해주세요</div>
          <button type="button" className="resume-select-modal__close" onClick={onClose} aria-label="닫기">
            ×
          </button>
        </div>

        <ul className="resume-select-modal__list">
          {resumeList.map((item) => (
            <li key={item.id}>
              <button type="button" className="resume-select-modal__item" onClick={() => onSelect(String(item.id))}>
                <div className="resume-select-modal__item-title">
                  {!!Number(item.isPublic) && <span className="resume-select-modal__badge">공개</span>}
                  <span>{item.title || '제목 없는 이력서'}</span>
                </div>
                <div className="resume-select-modal__item-meta">
                  {item.updatedAt && <span>수정일 {formatDate(item.updatedAt)}</span>}
                  {item.hasSelfIntroduction && <span>자기소개서</span>}
                  {(item.portfolioCount ?? 0) > 0 && <span>포트폴리오 {item.portfolioCount}</span>}
                </div>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
